import React from 'react';

import Link from './Link';

export default ({ data, deleteLink, header }) => (
    <div className="linkRow">
        {data.map(link => (
            <Link
                deleteLink={deleteLink}
                key={link.image}
                lang={header}
                {...link}
            />
        ))}
    </div>
);
